import { MtUser, MtGroup, MtProjectGroup } from "server/models"
import { ProjectPermissionsSectioned } from "client/store/utils"
import {
    UserFilters,
    GroupFilters,
    ProjectGroupFilters,
} from "client/store"
import { OrderType } from "client/utils"


export interface ProjectPermissionsState {
    projectPermissions: ProjectPermissionsSectioned

    accountGroups: {
        groupIds: readonly number[]
        sortColumn: keyof MtGroup
        sortOrder: OrderType
        filters: GroupFilters
        selected: readonly number[]
    }
    projectGroups: {
        groupIds: readonly number[]
        sortColumn: keyof MtProjectGroup
        sortOrder: OrderType
        filters: ProjectGroupFilters
        selected: readonly number[]
    }
    projectUsers: {
        userIds: readonly number[]
        sortColumn: keyof MtUser
        sortOrder: OrderType
        filters: UserFilters
        selected: readonly number[]
    }

    reloadList: boolean
}

export const SET_PROJECT_PERMISSIONS = "SET_PROJECT_PERMISSIONS"

export const UPDATE_PROJECT_PERMISSION = "UPDATE_PROJECT_PERMISSION"
export const TOGGLE_PROJECT_PERMISSION_CUSTOMIZABLE = "TOGGLE_PROJECT_PERMISSION_CUSTOMIZABLE"

export const PROJECT_PERMISSIONS_ACCOUNT_GROUP_IDS = "PROJECT_PERMISSIONS_ACCOUNT_GROUP_IDS"
export const PROJECT_PERMISSIONS_ACCOUNT_GROUP_SORT = "PROJECT_PERMISSIONS_ACCOUNT_GROUP_SORT"
export const PROJECT_PERMISSIONS_ACCOUNT_GROUP_FILTERS = "PROJECT_PERMISSIONS_ACCOUNT_GROUP_FILTERS"
export const PROJECT_PERMISSIONS_ACCOUNT_GROUP_SELECTED = "PROJECT_PERMISSIONS_ACCOUNT_GROUP_SELECTED"

export const PROJECT_PERMISSIONS_PROJECT_GROUP_IDS = "PROJECT_PERMISSIONS_PROJECT_GROUP_IDS"
export const PROJECT_PERMISSIONS_PROJECT_GROUP_SORT = "PROJECT_PERMISSIONS_PROJECT_GROUP_SORT"
export const PROJECT_PERMISSIONS_PROJECT_GROUP_FILTERS = "PROJECT_PERMISSIONS_PROJECT_GROUP_FILTERS"
export const PROJECT_PERMISSIONS_PROJECT_GROUP_SELECTED = "PROJECT_PERMISSIONS_PROJECT_GROUP_SELECTED"

export const PROJECT_PERMISSIONS_PROJECT_USER_IDS = "PROJECT_PERMISSIONS_PROJECT_USER_IDS"
export const PROJECT_PERMISSIONS_PROJECT_USER_SORT = "PROJECT_PERMISSIONS_PROJECT_USER_SORT"
export const PROJECT_PERMISSIONS_PROJECT_USER_FILTERS = "PROJECT_PERMISSIONS_PROJECT_USER_FILTERS"
export const PROJECT_PERMISSIONS_PROJECT_USER_SELECTED = "PROJECT_PERMISSIONS_PROJECT_USER_SELECTED"

export const PROJECT_PERMISSIONS_RELOAD_LIST = "PROJECT_PERMISSIONS_RELOAD_LIST"
